export default __webpack_public_path__ + "static/media/ProgettoZEUS_ArticoloITA_31Dicembre2020.8ae1d505.pdf";